import { render } from "./ImporterNav.vue?vue&type=template&id=c2653c6e&scoped=true"
import script from "./ImporterNav.vue?vue&type=script&lang=js"
export * from "./ImporterNav.vue?vue&type=script&lang=js"

import "./ImporterNav.vue?vue&type=style&index=0&id=c2653c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2653c6e"]])

export default __exports__